<template>
    <div class="confirm">
        <div v-if="STEP==1">
            <div class="title"> {{TYPE}}</div>
            <div class="info">
                <ul class="ul">
                    <li>
                        <b>•基本信息</b>
                        <!-- <div><span class="textright">体检套餐：</span><span>“1+X”个性化套餐</span></div> -->
                        <div><span class="textright">体检人：</span><span>{{NAME}}</span></div>
                        <div>
                            <span class="textright">联系电话：</span><span>{{PHONE_NUM}}</span>
                        </div>
                    </li>
                    <li>
                        <b>预约信息</b>
                        <!-- <h1>预约日期：2018-6-8 15:34:10</h1> -->
                        <!-- <div class="yy"> -->
                        <van-field v-model="yydate" label="预约日期：" placeholder="请选择预约日期" @click="clickShowdate" readonly class="warnings" error/>
                        <van-field v-model="yytime" label="预约时间：" placeholder="请选择预约时间" @click="clickShowtime" readonly class="warnings" error/>
                        <!-- </div> -->
                    </li>
                    <li>
                        <b>预约须知</b>
                        <ul class="info2">
                            <li>1.请合理安排您的预约时间，按时体检。</li>
                            <li>2.若需改约，请提前24小时致电客服改约，联系电话：0512-56995618，谢谢。</li>
                            <!-- <li>3.提供准确的早期预警，让您更好的了解目前身体状况。</li> -->
                        </ul>
                    </li>
                </ul>
            </div>
            <div class="buy">
                <div class="price">
                    <span class="cf4">日期：{{fullTime}}</span>
                </div>
                <button class="btnbuy" @click="submit">确认预约</button>
            </div>
            <van-popup v-model="show" position="bottom">
                <van-datetime-picker v-model="currentDate" :min-date="minDate" type="date" @confirm="confirmDate" @cancel="show=false" />
            </van-popup>
            <van-popup v-model="showTime" position="bottom">
                <van-picker :columns="intervals" title="请选择预约时间" show-toolbar @confirm="onConfirm" @cancel="onCancel" />
                <!-- <ul class="time">
                            <li v-for="(li,index) in intervals" :key="index" @click="timeSel(li)" :disabled="li.disabled">{{li.TIME}}</li>
                        </ul> -->
            </van-popup>
        </div>
        <div v-else>
            <yuyueSuccess></yuyueSuccess>
        </div>
    </div>
</template>

<script>
    import {
        mapGetters
    } from 'vuex';
    import {
        Dialog,
        Toast,
        DatetimePicker
    } from 'vant';
    import api from "@/fetch/api";
    import yuyueSuccess from '@/pages/yuyueSuccess';
    export default {
        data() {
            return {
                TYPE: '',
                NAME: '',
                PHONE_NUM: '',
                orderID: '',
                addItems: [],
                basicItems: [],
                totalPrice: 0,
                show: false,
                showTime: false,
                wx: true,
                zfb: false,
                yydate: '',
                yytime: '',
                currentDate: new Date(),
                minDate: new Date(new Date().getTime() + 24*60*60*1000),
                intervals: [],
                fullTime: '',
                STEP: 1
            }
        },
        components: {
            yuyueSuccess
        },
        beforeRouteEnter(to, from, next) {
            next((vm) => {
                vm.getOrderInfo(vm)
            })
        },
        computed: {
            ...mapGetters(["loginStatus", "userInfo"]),
        },
        methods: {
            clickShowdate() {
                this.show = true;
                //解决ios端设置了readonly仍然有一层“完成”
                document.activeElement.blur();
            },
            clickShowtime() {
                this.showTime = true;
                //解决ios端设置了readonly仍然有一层“完成”
                document.activeElement.blur();
            },
            confirmDate(value) {
                let date = value;
                this.yydate = date.getFullYear() + '-' + (Array(2).join(0) + (date.getMonth() + 1)).slice(-2) + '-' + (Array(2).join(0) + date.getDate()).slice(-2);
                this.bindInterval(this.yydate);
                this.show = false;
                this.fullTime = [this.yydate, this.yytime].join(' ');
            },
            getOrderInfo(el) {
                this.orderID = el.$route.params.orderID;
                console.log(this.orderID);
                // let now = new Date(); //获取当前时间
                // this.minDate = new Date(now.getTime() + 24*60*60*1000);
                var record = JSON.parse(sessionStorage.getItem('records'));
                this.TYPE = record.TYPE;
                this.NAME = record.NAME;
                this.PHONE_NUM = record.PHONE_NUM;
                api.queryMyOrderItems(this.orderID).then(re => {
                    let data = re.data;
                    this.addItems = data.addItems;
                    this.basicItems = data.basicItems;
                });
                this.totalPrice = parseFloat(record.PRICE);
            },
            submit() {
                // this.$emit('steps',2);
                let params = {
                    PRESET_TIME: this.fullTime
                };
                api.order(this.orderID, params).then(re => {
                    if (re.result == true) {
                        //  this.$router.back(-1);
                        this.STEP = 2;
                    }
                })
                // this.$router.push('/user/yuyueSuccess');
            },
            bindInterval(date) {
                this.intervals.splice(0, this.intervals.length);
                api.findIntervalByDate(date).then(re => {
                    re.data.forEach(el => {
                        this.intervals.push({
                            // TIME: el.START_TIME + '~' + el.END_TIME,
                            // PRESET_NUM: el.PRESET_NUM,
                            // ONLINE_NUM: el.ONLINE_NUM,
                            // disabled: true
                            text: el.START_TIME + '~' + el.END_TIME + '(已预约' + el.PRESET_NUM + '人，上限' + el.ONLINE_NUM + '人)',
                            TIME: el.START_TIME + '~' + el.END_TIME,
                            disabled: el.PRESET_NUM >= el.ONLINE_NUM
                            //  disabled: 40>=el.ONLINE_NUM
                        })
                    });
                })
            },
            // timeSeltimeSel(interval) {
            //     if (!interval.disabled) {
            //         this.yytime = interval.TIME;
            //         this.showTime = false;
            //         this.fullTime = [this.yydate, this.yytime].join(' ');
            //     }
            // },
            onConfirm(value, index) {
                let interval = this.intervals[index];
                this.yytime = interval.TIME;
                this.showTime = false;
                this.fullTime = [this.yydate, this.yytime].join(' ');
            },
            onCancel() {
                this.showTime = false;
            }
        },
        created() {}
    }
</script>

<style scoped lang='less'>
    .confirm {
.warnings{
    font-size: 1rem;
    font-weight: bold;
    color:#f44 !important;

    
}


        .pay {
            .head {
                padding: 0.5em;
                position: relative;
                text-align: center;
                border-bottom: 1px solid rgb(226, 226, 226);
                .iconfont {
                    position: absolute;
                    left: 0.3em;
                    top: 0.4em;
                }
            }
            button {
                background: #99C51D;
                margin: 4em 1em 1em 1em;
                color: #fff;
                font-weight: bold;
                font-size: 1rem;
                width: 95%;
                border-radius: 10px;
                height: 2em;
            }
            h1 {
                text-align: center;
                font-weight: normal;
                padding: 1em 0 0.3em 0;
            }
            ul {
                li {
                    font-size: 0.8rem;
                    color: #333;
                    border-bottom: 1px solid #eee;
                }
            }
        }
        .buy {
            padding-left: 1rem;
            .btnbuy {
                padding: 0 1em;
            }
            .price {
                span {
                    display: inline;
                    font-size: 0.8rem !important;
                }
            }
        }
        .title {
            height: 2em;
            font-size: 0.95rem;
            border-width: 4px;
            border-style: solid;
            border-color: #43852E;
            border-top: 0px;
            border-right: 0px;
            border-bottom: 0px;
            border-radius: 0px;
            line-height: 2em;
            padding-left: 1em;
            font-weight: bold;
            border-bottom: 1px solid rgb(226, 226, 226);
            color: #666;
        }
        .ul {
            li {
                color: #99C51D;
                font-size: 0.8rem;
                border-bottom: 1px solid #eee;
                padding: 0.5em 1em;
                .info2 {
                    >li {
                        color: #666;
                        border: 0;
                        padding: 0;
                        line-height: 1.5em;
                    }
                }
                b {
                    line-height: 2em;
                }
                >h1 {
                    background: rgba(246, 246, 246, 1);
                    font-size: 1rem;
                    line-height: 3em;
                    height: 3em;
                    color: red;
                    text-align: center;
                    font-weight: normal;
                }
                .yy {
                    background: rgba(246, 246, 246, 1);
                    font-size: 1rem;
                    line-height: 3em;
                    height: 3em;
                    color: red;
                    text-align: center;
                    font-weight: normal;
                }
                >div {
                    color: #666;
                    line-height: 2em;
                    span {
                        display: inline-block;
                        min-width: 6em;
                        margin-right: 1em;
                    }
                    padding-bottom: 0.5em;
                }
            }
        }
        .time {
            li {
                border-bottom: 1px solid #f0f0f0;
                line-height: 3rem;
                text-align: center;
            }
            i {
                color: #999;
            }
            .active {
                color: #99C51D;
            }
            span {
                font-size: 18px;
            }
        }
        .noinput {
            pointer-events: none;
        }
    }
</style>


// WEBPACK FOOTER //
// src/pages/singleYuYue.vue